/* eslint-disable */
import React, { useRef } from "react";

function DashboardReport() {
  const iframeUrl =
    "https://sp.pdtra.gov.jo/portal/apps/dashboards/169353b30cdd41829a4728291a096c50";
  const iframeRef = useRef();

  return (
    <>
      <h2 className="content__title title mt-3">لوحة البيانات</h2>
      <iframe
        title="My Dashboard"
        src={iframeUrl}
        width="100%"
        height="600px"
        allowFullScreen
        ref={iframeRef}
        // onLoad={handleIframeLoad}
      />
    </>
  );
}

export default DashboardReport;